export default {
  __name: 'Layout',
  setup(__props) {
    return {
      __sfc: true
    };
  }
};